import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

const NetworkStatusProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const updateNetworkStatus = () => {
    setIsOnline(navigator.onLine);
    if (navigator.onLine) {
      enqueueSnackbar('You are back online!', { variant: 'success' });
    } else {
      enqueueSnackbar('You are offline. Some features may not be available.', { variant: 'warning' });
    }
  };

  useEffect(() => {
    window.addEventListener('online', updateNetworkStatus);
    window.addEventListener('offline', updateNetworkStatus);

    return () => {
      window.removeEventListener('online', updateNetworkStatus);
      window.removeEventListener('offline', updateNetworkStatus);
    };
  }, []);

  return <>{children}</>;
};

export default NetworkStatusProvider;
